import { useForm, Head } from '@inertiajs/react'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { Alert, AlertDescription } from '@/components/ui/alert'

interface LoginProps {
  errors: Record<string, string[]>
  email?: string
}

export default function Login({ errors, email: initialEmail = '' }: LoginProps) {
  const { data, setData, post, processing } = useForm({
    email: initialEmail,
    password: '',
  })

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    post('/login')
  }

  return (
    <>
      <Head title="Sign In | Osher Fleet" />
      <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
        <Card className="w-full max-w-md">
        <CardHeader className="space-y-1">
          <CardTitle className="text-2xl font-bold">Osher Fleet Dashboard</CardTitle>
          <CardDescription>
            Sign in to manage your n8n instances
          </CardDescription>
        </CardHeader>
        <CardContent>
          {errors.email && (
            <Alert variant="destructive" className="mb-4">
              <AlertDescription>{errors.email[0]}</AlertDescription>
            </Alert>
          )}
          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="space-y-2">
              <Label htmlFor="email">Email</Label>
              <Input
                id="email"
                type="email"
                placeholder="you@example.com"
                value={data.email}
                onChange={(e) => setData('email', e.target.value)}
                required
                autoComplete="email"
                autoFocus
              />
            </div>
            <div className="space-y-2">
              <Label htmlFor="password">Password</Label>
              <Input
                id="password"
                type="password"
                value={data.password}
                onChange={(e) => setData('password', e.target.value)}
                required
                autoComplete="current-password"
              />
            </div>
            <Button type="submit" className="w-full" disabled={processing}>
              {processing ? 'Signing in...' : 'Sign in'}
            </Button>
          </form>
        </CardContent>
        </Card>
      </div>
    </>
  )
}
